<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="t('attendanceDialog.payslipDetailTitle')" width="800" draggable>
            <div class="userAdd_man">
                <el-form label-width="auto" :model="state.form" class="userFrom">
                    <el-col :span="12">
                        <el-form-item :label="t('salary.name')"><span>{{ state.form.real_name }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.month')"><span>{{ state.form.time }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.totalEarnings')"><span>{{ state.form.total_earnings }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.allowance')"><span>{{ state.form.allowance_amount }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.deduction')"><span>{{ state.form.total_deductions }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.mpfDeduction')"><span>{{ state.form.mpf_deduction ?? 0 }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.netPay')"><span>{{ state.form.net_pay }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.incomeAfterMpf')"><span>{{ state.form.income_after_mpf ?? 0 }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.clockDays')"><span>{{ state.form.gotowork }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.annualLeaveDays')"><span>{{ state.form.annual_leave_day ?? 0 }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendanceDialog.annualLeavePay')"><span>{{ state.form.annual_leave_pay ?? '—' }}</span></el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('attendanceDialog.attendanceNote')">
                            <span class="note-text">{{ state.form.annual_leave_attendance_note || t('attendance.none') }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.otDays')"><span>{{ state.form.otday }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.otHours')"><span>{{ state.form.ottime }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.zhiDays')"><span>{{ state.form.zhiday }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.zhiHours')"><span>{{ state.form.zhitime }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.lateCount')"><span>{{ state.form.chiday }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendance.earlyLeaveCount')"><span>{{ state.form.zaotui }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('attendanceDialog.sundayOtDays')"><span>{{ state.form.riday }}</span></el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="t('salary.nightShiftDays')"><span>{{ state.form.night_shift_day ?? 0 }}</span></el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('salary.remarks')"><span>{{ state.form.remarks }}</span></el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="state.dialogVisible = false">{{ t('improveDetail.close') }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, defineExpose } from "vue";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const state = reactive({
    dialogVisible: false,
    form: {
        id: null, real_name: "", time: "", total_earnings: "", allowance_amount: "",
        total_deductions: "", mpf_deduction: "", net_pay: "", income_after_mpf: "",
        gotowork: 0, annual_leave_day: 0, annual_leave_pay: "", annual_leave_attendance_note: "",
        otday: 0, ottime: 0, zhiday: 0, zhitime: 0, chiday: 0, zaotui: 0, riday: 0,
        night_shift_day: 0, remarks: "",
    },
});

const open = (row = {}) => {
    if (row?.id) state.form = { ...state.form, ...row };
    state.dialogVisible = true;
};

usePageI18n(() => {});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}
.userFrom {
    display: grid;
    gap: 20px;
}
.note-text {
    color: #606266;
    line-height: 1.5;
}
</style>
